import './login.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../services/AppContext';

const Login = () => {
    const { t } = useTranslation();
    const { apiClient, setIsAuthorized, setUser } = useContext(AppContext);
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const result = await apiClient.login({ username, password });

            if (result.token) {
                const user = {
                    id: result.id,
                    role: result.role,
                    name: result.name,
                };
                apiClient.setState({
                    token: result.token,
                    user: user,
                });
                setIsAuthorized(true);
                setUser(user);
                navigate('/');
            }
        } catch (error) {
            console.error(t('pages.login.errorMessage'), error);
        }
    };

    return (
        <div className="login-container">
            <h2 className="login-title">{t('pages.login.title')}</h2>
            <form onSubmit={handleLogin} className="login-form">
                <label htmlFor="username">{t('pages.login.usernameLabel')}</label>
                <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <label htmlFor="password">{t('pages.login.passwordLabel')}</label>
                <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit" className="login-button">
                    {t('pages.login.submitButton')}
                </button>
            </form>
        </div>
    );
};

export default Login;